const search = document.getElementById('search');
const searchIcon = document.querySelector('.search__icon');

const closeSearch = function () {
    search.classList.remove('open');
    searchIcon.classList.remove('open');
};

const openCloseSearch = function () {
    search.classList.toggle('open');
    searchIcon.classList.toggle('open');
};

const showHideSearchIcon = function (state = 'toggle') {
    const searchIcon = document.querySelector('.header-menu .search__icon');

    if (state == 'toggle') {
        searchIcon.classList.toggle('hide');
    } else if (state == 'hide') {
        searchIcon.classList.add('hide');
    } else {
        searchIcon.classList.remove('hide');
    }
    closeSearch();
}

const submitSearchForm = function () {
    const searchForm = document.querySelector('#search form');
    searchForm.submit();
}

const searchIcons = document.querySelectorAll('.search__icon');

for (const icon of searchIcons) {
    icon.addEventListener('click', function () {
        //Confusing but mobile designs came after this was built and had to tweak
        // if (screenState == screenSize.TabletPortrait || screenState == screenSize.Mobile) {
        //     //Mobile / Tablet Portrait
        //     openCloseSearch();
        // } else {
            //Desktop
            if (search.classList.contains('open')) {
                submitSearchForm();
            } else {
                openCloseSearch();
            }
        // }

    });
}
document.querySelector('.search__input .icon-close').addEventListener('click', function () {
    // //Confusing but mobile designs came after this was built and had to tweak
    // if (screenState == screenSize.TabletPortrait || screenState == screenSize.Mobile) {
    //     //Mobile / Tablet Portrait
    //     if (search.classList.contains('open')) {
    //         submitSearchForm();
    //     } else {
    //         openCloseSearch();
    //     }
    // } else {
        //Desktop
        openCloseSearch();
    // }
})